import * as actions from './actionTypes';

export default (state = {email: '', password: '', authfailed: false}, action) => {
  switch (action.type) {
    case actions.LOGIN:
      return Object.assign({}, state, action.payload)
    case actions.EDIT:
      return action.payload
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/user/reducer.js